export default {
  title: 'Model Composer',
  emptyState: 'Agrega un canal para empezar.',
  channelsPending: 'Completa el canal nuevo: indica dónde se satura y sus ventas en ese punto. | Completa los {count} canales pendientes: indica dónde se satura cada uno y sus ventas en ese punto.',
  channelsCompare: 'Curvas de saturación',
  // Pasos, y por qué Siguiente está deshabilitado en cada uno.
  stepDetails: 'Configuración',
  stepChannels: 'Canales de medios',
  stepSpend: 'Inversión en medios',
  stepRevenue: 'Ventas',
  stepOtherInputs: 'Otros inputs',
  stepFutureTrends: 'Tendencias futuras',
  stepPreview: 'Vista previa',
  stepHintSource: 'Elige cómo empezar.',
  stepHintDetails: 'Ingresa un nombre y un mercado para continuar.',
  stepHintCopyModel: 'Elige un modelo para copiar y continuar.',
  stepHintChannels: 'Agrega al menos un canal para continuar.',
  stepHintRevenue: 'Ingresa las ventas totales para continuar.',
  create: 'Crear modelo',
  name: 'Nombre del modelo',
  nameRequired: 'El nombre es obligatorio.',
  market: 'Mercado',
  currency: 'Moneda',
  frequency: 'Frecuencia',
  frequencyMonthly: 'Mensual',
  frequencyWeekly: 'Semanal',
  history: 'Historia',
  historyYears: '{n} año | {n} años',
  comingSoon: 'Próximamente',
  addKpi: 'Agregar KPI',
  addInput: 'Agregar input',
  // Future trends
  futureTrendsIntro: 'Opcional. Cuánto se espera que crezca cada serie en los próximos 12 meses. 0% significa igual que el año pasado.',
  growthSales: 'Ventas',
  growthSalesInfo: 'Crecimiento esperado de las ventas totales en los próximos 12 meses, como un rango.',
  growthMedia: 'Inversión en medios',
  growthMediaInfo: 'Crecimiento esperado de la inversión en los canales de este modelo en los próximos 12 meses.',
  growthOtherInfo: 'Crecimiento esperado de esta inversión en los próximos 12 meses.',
  growthMin: 'Crecimiento mín.',
  growthMax: 'Crecimiento máx.',
  growthLastYear: 'Últimos 12 meses',
  growthNextYear: 'Próximos 12 meses',
  growthChange: 'Cambio',
  growthNoChange: 'Igual que el año pasado',
  growthPastGroup: 'Últimos 12 meses',
  growthFutureGroup: 'Próximos 12 meses (esperado)',
  growthPastColumn: 'Año pasado',
  growthNextColumn: 'Próximo año',
  growthLegendPast: 'Declarado',
  growthLegendFuture: 'Rango esperado',
  growthLegendMark: 'Mismo mes del año pasado',
  recapFutureTrends: 'Crecimiento de ventas',
  // Otros inputs
  otherInputsIntro: 'Opcional. Otras inversiones que el modelo debe considerar.',
  otherComarketing: 'Co-marketing',
  otherComarketingInfo: 'Inversión de la marca fuera de esta categoría, como publicidad a nivel de marca. Solo se necesita el total.',
  otherCompetition: 'Competencia',
  otherCompetitionInfo: 'Inversión total en medios de los competidores directos en esta categoría.',
  otherTotal: 'Inversión total',
  otherAvgMonthInfo: 'Promedio mensual. Al editarlo se actualiza el total.',
  otherFlatten: 'Aplanar: hacer los meses más parejos',
  otherRandomize: 'Aleatorizar: hacer los meses más irregulares',
  otherShiftLeft: 'Adelantar un mes',
  otherShiftRight: 'Atrasar un mes',
  otherClear: 'Borrar',
  otherAttribution: 'Atribución (% de ventas)',
  otherAttributionInfo: 'Parte de las ventas del año atribuida a esta inversión, de 0% a 100%. Es obligatoria cuando hay un total.',
  otherAttributionInfoCompetition: 'Parte de las ventas del año que resta la competencia, de -100% a 0%. Es obligatoria cuando hay un total.',
  otherAttributionHint: '≈ {amount} de ventas',
  otherAttributionHeld: 'Limitada a {cap}%: el marketing, la estacionalidad y la competencia no dejan más margen.',
  otherAttributionBlank: 'Obligatoria.',
  stepHintOtherAttribution: 'Indica la atribución de cada input con total para continuar.',
  otherAttributionNeedsSpend: 'Primero ingresa un total.',
  decompositionComarketingName: 'Co-marketing',
  decompositionCompetitionName: 'Competencia',
  decompositionComarketing: 'el {share}% de las ventas atribuido al co-marketing. Sale de las ventas base.',
  decompositionCompetition: 'el {share}% de las ventas que resta la competencia. Vuelve a las ventas base.',
  decompositionOtherChosenByModel: 'no queda margen para su parte de las ventas, así que la elegirá el modelo. Aquí no tiene barra.',
  decompositionOtherByPeriodNote: 'El co-marketing y la competencia se reparten entre los meses según su inversión. El modelo construido agrega saturación y arrastre, así que sus meses van a diferir.',
  inputMarketingSpend: 'Inversión en medios',
  inputSeriesName: 'Input {name}',
  otherImport: 'Importar la forma mensual de otro modelo',
  otherSheetShow: 'Editar como tabla',
  marketRequired: 'El mercado es obligatorio.',
  noSourceModels: 'No hay modelos con un reporte terminado.',
  noCopyModels: 'No hay modelos disponibles para copiar.',
  catalogueRestricted: 'Solo se listan los modelos a los que tienes acceso.',
  reportEmpty: 'Este modelo todavía no tiene reporte.',
  reportLoadFailed: 'No se pudo cargar el reporte de este modelo: {error}',
  // Cómo empieza una composición
  sourceQuestion: '¿Cómo quieres empezar?',
  sourceScratch: 'Desde cero',
  sourceScratchNote: 'Agrega canales de tus modelos, uno por uno.',
  sourceCopy: 'Copiar un modelo',
  sourceCopyNote: 'Parte de un modelo existente y edítalo.',
  copyModel: 'Modelo a copiar',
  copyName: '{name} (copia)',
  copyFailed: 'No se pudo cargar este modelo.',
  copyNothing: 'Ninguno de los canales de este modelo se puede copiar.',
  copyDone: 'Se copió {channels} canal, con ventas de {revenue}. Puedes editar todo en los pasos siguientes. | Se copiaron {channels} canales, con ventas de {revenue}. Puedes editar todo en los pasos siguientes.',
  copySkippedTitle: 'Canales que no se pudieron copiar',
  copyHeldMonths: 'La estacionalidad de {months} se limitó a {cap}% de las ventas base.',
  copyAskTitle: '¿Reemplazar tus canales?',
  copyAsk: 'Copiar un modelo reemplaza el canal que agregaste y todo lo que configuraste en él. | Copiar un modelo reemplaza los {channels} canales que agregaste y todo lo que configuraste en ellos.',
  copyAskConfirm: 'Reemplazar',
  // Agregar canales
  addChannels: 'Agregar canales',
  importFromModels: 'Importar desde modelos',
  importFromModelsNote: 'Toma canales, con sus curvas, de modelos existentes.',
  chooseModel: 'Elegir modelo…',
  changeModel: 'Cambiar',
  copyImporterTitle: 'Elige un modelo para copiar',
  copyImporterSubtitle: 'Busca por nombre o filtra por país, cliente, marca o categoría.',
  channelImporterTitle: 'Importar canales',
  channelImporterSubtitle: 'Busca por modelo o canal, y filtra por datos del modelo o taxonomía del canal.',
  importerSearchModels: 'Buscar modelos',
  importerSearchChannels: 'Buscar canales o modelos',
  importerModelFacets: 'Modelo',
  importerTaxonomyFacets: 'Taxonomía del canal',
  importerNoMetadata: 'Estos modelos todavía no tienen metadatos. Puedes buscarlos por nombre.',
  importerNoModelMatch: 'Ningún modelo coincide con estos filtros.',
  importerNotSet: 'Sin definir',
  importerCurrent: 'Actual',
  importerChangeModel: 'Cambiar modelo',
  importerAllChannels: 'Seleccionar todos los canales de {model}',
  importerPickHint: 'Haz clic en un modelo para elegirlo.',
  importerFacetCountry: 'País',
  importerFacetClient: 'Cliente',
  importerFacetBrand: 'Marca',
  importerFacetCategory: 'Categoría',
  importerFacetSubcategory: 'Subcategoría',
  addFromScratch: 'Desde cero',
  addFromScratchNote: 'Crea un canal y define tú mismo sus curvas.',
  taxonomyFilters: 'Filtros',
  taxonomyClear: 'Limpiar filtros',
  taxonomyRemoveFilter: 'Quitar filtro',
  taxonomyOnlyClassified: 'Solo canales clasificados',
  taxonomyUnclassified: 'Sin clasificar',
  taxonomyShowAll: 'Ver todos ({count})',
  taxonomyShowLess: 'Ver menos',
  taxonomyShowMore: 'Ver más',
  taxonomyShowing: 'Mostrando {shown} de {total}',
  taxonomyNoMatch: 'Ningún canal coincide con estos filtros.',
  taxonomyNoneYet: 'Ningún canal tiene taxonomía todavía. Puedes buscarlos por nombre.',
  taxonomyCatalogueLoading: 'Cargando modelos…',
  taxonomyReading: 'Leyendo {count} modelo… | Leyendo {count} modelos…',
  taxonomyModels: '{count} modelo | {count} modelos',
  taxonomySummary: '{channels} de {models}',
  taxonomyNotInReport: 'Este canal no está en el reporte de su modelo.',
  taxonomyReadFailed: 'No se pudo cargar el reporte de este modelo.',
  scratchChannel: 'Canal nuevo',
  fromScratchOrigin: 'Desde cero',
  pickerAdd: 'Agregar canales | Agregar {count} canal | Agregar {count} canales',
  pickerAlready: 'Ya agregado',
  pickerModelAdded: '{count} canal ya agregado | {count} canales ya agregados',
  pickerAddHint: 'Agregar los canales seleccionados (⌘/Ctrl + Enter)',
  pickerNotMeasured: 'Sin medición',
  pickerAdded: 'Agregado',
  pickerPlotSaturation: 'Saturación: ventas que genera cada nivel de inversión mensual.',
  pickerPlotDecay: 'Decaimiento: cómo se prolonga el efecto en los meses siguientes.',
  pickerLoadingNote: 'Cargando el modelo…',
  pickerCount: '{count} canal | {count} canales',
  pickerSelected: '{count} seleccionados',
  pickerSelectAll: 'Seleccionar todos los canales visibles',
  notReadyTitle: 'Este modelo no puede aportar canales',
  notReady_noKpi: 'No tiene historia de ventas.',
  notReady_noChannels: 'Ninguno de sus canales tiene a la vez historia de inversión y curva de saturación.',
  skipped_noSaturation: '{channel}: sin una curva de saturación utilizable.',
  skipped_noCurve: '{channel}: su curva de saturación tiene muy pocos puntos.',
  unbuiltAction: 'Completar',
  channelEditTitle: 'Editar {channel}',
  channelName: 'Nombre del canal',
  editorPrev: 'Canal anterior',
  editorNext: 'Canal siguiente',
  saturationCurve: 'Curva de saturación',
  saturationPoint: 'Punto de saturación',
  responseShape: 'Forma de la respuesta',
  // Decaimiento
  decayTitle: 'Decaimiento',
  decayLagAt: 'Mes {month}',
  decayImported: 'Como se importó',
  decayCustom: 'Personalizado',
  decayPeak: 'Pico {month}',
  decayShapeTitle: 'Pico en el mes {peak}; la mitad del efecto para el mes {half}',
  decayDrag: 'Arrastra la barra más alta: en horizontal para mover el pico, en vertical para cambiar qué tan rápido se desvanece.',
  decayShapeNow: 'Pico en el mes {peak} · la mitad del efecto para el mes {half}',
  decayAbout: 'Cómo sigue funcionando la inversión de un mes en los meses siguientes: cambia cuándo llegan las ventas, no cuántas. Los canales de modelos semanales necesitan que elijas una forma aquí.',
  statedOf: '{index} de {count}',
  statedSuffix: 'USD / mes',
  unbuiltBlocked: 'Sin curva disponible',
  unbuiltChannel: 'Indica dónde se satura {channel} y sus ventas en ese punto para incluirlo en el modelo.',
  unbuiltNoCurve: 'La curva de saturación de {channel} nunca se aplana, así que no se puede usar. Quítalo y elige otro canal.',
  // Inversión en medios
  metricSpend: 'Inversión en medios',
  metricSpendTotal: 'Inversión total',
  metricSpendInfo: 'Inversión total en medios del año. Elige un nivel en el gráfico o ingresa un ROAS total objetivo.',
  metricTotalKpi: 'Ventas totales',
  metricTotalKpiInfo: 'Ventas totales del año. Definen qué parte del negocio explica el marketing, y sus límites dependen de la inversión en medios.',
  metricAvgMonth: 'Prom. por mes',
  metricAvgMonthInfo: 'Promedio mensual. Al editarlo se actualiza el total.',
  metricRoas: 'ROAS total',
  metricRoasInfo: 'ROAS total estimado: ventas generadas por medios divididas por la inversión en medios. El modelo construido puede variar levemente.',
  tradePlotLabel: 'Retorno por inversión',
  tradeMinLabel: 'Inversión mín.',
  trade_min_attribution: 'Inversión mínima: por debajo, el marketing no explicaría casi nada de las ventas.',
  trade_min_floor: 'Inversión mínima: por debajo, la inversión mensual de algunos canales sería demasiado baja para modelarla.',
  trade_min_window: 'Menor inversión del gráfico. Haz clic para ir ahí.',
  tradeMaxLabel: 'Inversión máx.',
  trade_max_revenue: 'Inversión máxima: por encima, la inversión en medios superaría las ventas.',
  trade_max_base: 'Inversión máxima: por encima, a los medios se les atribuiría más que las ventas totales.',
  trade_max_attribution: 'Inversión máxima: por encima, a los medios se les atribuirían casi todas las ventas.',
  trade_max_window: 'Mayor inversión del gráfico. Haz clic para ir ahí.',
  spendSeated: 'La inversión en medios se ajustó a {spend}, el límite de este modelo.',
  spendSeatedChannels: 'La inversión en medios se ajustó a {spend}, el límite para los canales que quedan.',
  spendSeatedCurves: 'La inversión en medios se ajustó a {spend}, el límite tras los cambios en las curvas.',
  spendSeatedMonths: 'La inversión en medios se ajustó a {spend}, el límite tras los cambios mensuales.',
  spendHeld: 'La inversión en medios se mantuvo en {spend}.',
  // Ventas limitadas o ajustadas para quedar dentro de los límites
  revenueHeld_spend: 'Las ventas se mantuvieron en {revenue}: deben ser mayores que la inversión en medios. Baja la inversión para ir más abajo.',
  revenueSeated_spend: 'Las ventas se ajustaron a {revenue} para quedar por encima de la inversión en medios. Baja la inversión para ir más abajo.',
  monthHeld_spend: '{month} se mantuvo en {amount}: las ventas del año deben ser mayores que la inversión en medios.',
  revenueHeld_base: 'Las ventas se mantuvieron en {revenue}, el mínimo para esta inversión en medios. Baja la inversión para ir más abajo.',
  revenueSeated_base: 'Las ventas se ajustaron a {revenue}, el mínimo para la inversión en medios actual. Baja la inversión para ir más abajo.',
  monthHeld_base: '{month} se mantuvo en {amount}: más abajo, a los medios se les atribuiría más que las ventas totales.',
  revenueFloorHint: 'Mínimo con esta inversión: {revenue}',
  revenueHeld_low: 'Las ventas se mantuvieron en {revenue}, el mínimo permitido.',
  revenueHeld_high: 'Las ventas se mantuvieron en {revenue}: más arriba, los medios no explicarían casi nada de las ventas. Agrega canales o sube la inversión en medios.',
  revenueSeated_low: 'Las ventas se ajustaron a {revenue}, el mínimo permitido.',
  revenueSeated_high: 'Las ventas se ajustaron a {revenue}, el máximo para la inversión en medios actual. Sube la inversión para ir más arriba.',
  tradePeakLabel: 'ROAS máx.',
  tradePeak: 'Mayor retorno por dólar. Más allá, cada dólar extra rinde menos. Haz clic para ir ahí.',
  baseBelowFloor: 'Las ventas base están por debajo del mínimo de {floor} para esta inversión en medios. Sube las ventas a {revenue} o más, o baja la inversión en medios.',
  roasOutOfReach: 'No se puede alcanzar este ROAS total. Con esta mezcla va de {min} a {max}.',
  roasUnsolvable: 'Ninguna inversión en medios alcanza este ROAS total.',
  roasOutOfReachEither: 'No se puede alcanzar este ROAS total. Con esta mezcla va de {min} a {max}; con cualquier mezcla, de {mixMin} a {mixMax}.',
  roasHeldAt: 'Se ajustó hasta donde permiten las curvas: el ROAS total ahora es {roas}.',
  roasHeldFloor: 'Ese ROAS total requeriría dejar un canal casi sin inversión, así que la inversión se movió hasta donde fue posible.',
  mixMoved: 'Para alcanzar este ROAS total, el presupuesto se redistribuyó entre los canales. Las curvas no cambiaron.',
  spendMonthsLabel: 'Inversión mensual',
  spendMonthsKeys: 'Tab: siguiente campo · Enter: aplicar · Esc: cancelar',
  shapeMonthsKeys: 'Tab: siguiente campo · Enter: aplicar · Esc: cancelar',
  spendSheetChannels: 'Canal',
  spendSheetShow: 'Editar como tabla',
  sheetHide: 'Ocultar tabla',
  revenueSheetShow: 'Editar como tabla',
  sharesSheetShow: 'Editar como tabla',
  sheetSeries: 'Serie',
  revenueSheetHeld: 'Las ventas de {months} se ajustaron para quedar dentro del rango permitido.',
  shareSheetCell: '{row} en {month} ({value}% de la base)',
  shareSheetHeld: '{cells} se ajustaron para quedar dentro del rango permitido. {reasons}',
  shapeUnit: '% de la base',
  shapeCapNote: 'Cada valor es una parte de las ventas base de ese mes. Entre la estacionalidad y los eventos puntuales pueden tomar hasta el {cap}% de la base de un mes.',
  spendReturnKpi: 'Ventas',
  roasAxis: 'Ventas / Inversión',
  // Vista previa
  previewModelName: 'Vista previa del modelo',
  decayAxis: 'Meses después de la inversión',
  decompositionIntro: 'De dónde vienen las ventas de este modelo:',
  decompositionBase: 'las ventas sin ningún medio. El reporte del modelo construido las dividirá en base y ruido.',
  decompositionSeasonality: 'la parte de las ventas que viene de patrones anuales recurrentes. Mueve ventas entre meses, así que en el año suele sumar cerca de cero.',
  decompositionMarketingTerm: 'Marketing',
  decompositionMarketing: 'las ventas que generan todos los canales con la inversión en medios actual.',
  decompositionBaseBelowFloor: 'La estacionalidad y los eventos puntuales toman {claimed} de los {room} disponibles y dejan las ventas base por debajo del mínimo de {floor}. Redúcelos, o baja la inversión en medios y sube las ventas.',
  decompositionBaseNoRoom: 'Los medios ya explican todas las ventas salvo la base mínima de {floor}, así que no queda margen para estacionalidad ni eventos puntuales. Baja la inversión en medios o sube las ventas.',
  // Ventas por mes
  metricRevenueShape: 'Ventas',
  metricRevenueShapeInfo: 'Cómo se reparten las ventas totales entre los meses. Usa los botones para cambiar la forma, desplazar o importar el año, o haz clic en un mes para editarlo.',
  shapeRandomize: 'Aleatorizar: hacer los meses más irregulares',
  shapeFlatten: 'Aplanar: hacer los meses más parejos',
  shapeClear: 'Borrar',
  shapeShiftLeft: 'Adelantar un mes',
  shapeShiftRight: 'Atrasar un mes',
  shapeImport: 'Importar la forma mensual de otro modelo',
  shapeImportTitle: 'Importar la forma de las ventas',
  shapeImportSubtitle: 'Usa el patrón mensual de ventas de otro modelo. Tu total no cambia.',
  shapeImportKpi: 'KPI',
  shapeImportTotal: 'Total',
  shapeImportYear: 'Año',
  shapeImportAverage: 'Promedio de {count} años completos',
  shapeImportLoadingNote: 'Cargando el reporte…',
  shapeImportNoYears: 'Este modelo no tiene ningún año calendario completo.',
  shapeImportNoShape: 'Este KPI no tiene ventas en el año elegido.',
  shapeImportNote: 'Solo se usan años calendario completos. Tu total no cambia.',
  shapeImportShiftLeft: 'Adelantar un mes',
  shapeImportShiftRight: 'Atrasar un mes',
  shapeImportShifted: 'Desplazado {count} mes | Desplazado {count} meses',
  shapeImportSeason: 'Importar la estacionalidad de otro modelo',
  shapeShiftSeasonLeft: 'Adelantar un mes',
  shapeShiftSeasonRight: 'Atrasar un mes',
  shapeRandomizeSeason: 'Aleatorizar: marcar más la estacionalidad',
  shapeFlattenSeason: 'Aplanar: acercar ambas filas a cero',
  shapeClearSeason: 'Borrar',
  shapeImportSeasonTitle: 'Importar la estacionalidad',
  shapeImportSeasonSubtitle: 'Usa la estacionalidad medida en otro modelo. Los eventos puntuales no se importan.',
  shapeImportSeasonNoShape: 'Este modelo no tiene estacionalidad en el año elegido.',
  shapeImportSeasonNote: 'Solo se usan años calendario completos. Los meses que superan el tope se limitan a él.',
  shapeImportSeasonApply: 'Usar esta estacionalidad',
  shapeImportHeldMonths: '{months} se limitará a {cap}% de las ventas base.',
  shapeImportApply: 'Usar esta forma',
  shapeImportOtherTitle: 'Importar la forma',
  shapeImportOtherSubtitle: 'Usa el patrón mensual de una serie de medios o externa de otro modelo. El total no cambia.',
  shapeImportOtherSeries: 'Serie',
  shapeImportOtherMedia: 'Medios',
  shapeImportOtherMediaTotal: 'Inversión total en medios',
  shapeImportOtherExternal: 'Externas',
  shapeImportOtherNoSeries: 'Este modelo no tiene series de medios ni externas.',
  shapeImportOtherNoShape: 'Esta serie está vacía o es negativa en el año elegido.',
  shapeImportOtherNote: 'Solo se usan años calendario completos. El total no cambia.',
  shapeImportOtherNeedsTotal: 'Primero ingresa un total.',
  shapeImportOtherApply: 'Usar esta forma',
  monthHeld_low: '{month} se mantuvo en {amount}, el mínimo permitido.',
  monthHeld_high: '{month} se mantuvo en {amount}: más arriba, los medios no explicarían casi nada de las ventas.',
  // Estacionalidad y eventos puntuales
  metricSeasonality: 'Estacionalidad',
  seasonalitySection: 'Estacionalidad',
  metricSeasonalityNet: 'Neto del año',
  metricSeasonalityNetInfo: 'Suma de la estacionalidad en el año. Es normal que quede cerca de cero: mueve ventas entre meses.',
  seasonalityAbout: 'Patrones anuales recurrentes, como % de las ventas base de cada mes. Empieza plana.',
  seasonality_stop_attribution: 'Más allá de este punto, la atribución dejaría de sumar 100%.',
  shapesSection: 'Estacionalidad y eventos puntuales',
  shapesOptional: 'Opcional',
  metricShapesNet: 'Neto del año',
  metricSpot: 'Eventos puntuales',
  spotSection: 'Eventos puntuales',
  metricSpotNet: 'Neto del año',
  metricSpotNetInfo: 'Suma de los eventos puntuales en el año. A diferencia de la estacionalidad, no se compensan.',
  spotAbout: 'Eventos únicos, como un lanzamiento, una promoción o un quiebre de stock, como % de las ventas base de ese mes.',
  shapesHow: 'Haz clic en un mes para editar ambos valores. Salen de las ventas base y los limita el tope que aparece sobre el gráfico.',
  spot_stop_attribution: 'Más allá de este punto, la atribución dejaría de sumar 100%.',
  decompositionSpot: 'la parte de las ventas que viene de eventos únicos. Sale de las ventas base.',
  // Tarjetas de canal
  channels: 'Canales',
  channelsInfoMixed: 'El presupuesto ya no se reparte en partes iguales entre los canales.',
  channelRemove: 'Quitar {channel}',
  channelRemoveLast: 'Un modelo necesita al menos un canal.',
  channelRemoveTitle: '¿Quitar este canal?',
  channelRemoveText: 'Se quitarán {channel} y toda su configuración. Esta acción no se puede deshacer.',
  channelRemoveConfirm: 'Quitar',
  channelNameEmpty: 'Ingresa un nombre para el canal.',
  channelNameTaken: 'Ya hay otro canal con este nombre.',
  fromModel: '{model} · {channel}',
  saturation: 'Saturación',
  decay: 'Decaimiento',
  noCurve: 'Sin curva',
  spend: 'Inversión',
  lagMonths: 'Meses',
  cardPoint: '{channel} se satura en {knee} USD al mes y ahí genera {ceiling} USD al mes. Haz clic para editar.',
  cardPointUnstated: 'Punto de saturación sin definir. Haz clic para definirlo.',
  channelKnee: 'Se satura en',
  channelKneeTitle: 'Inversión mensual a partir de la cual {channel} deja de rendir: más allá, cada dólar extra rinde cada vez menos.',
  channelCeiling: 'Ventas en saturación',
  channelCeilingTitle: 'Ventas mensuales que genera {channel} en su punto de saturación.',
  // Editor de canal
  revenue: 'Ventas',
  curveEditAction: 'Editar canal',
  curveEditMoved: 'Editar {channel} (la línea punteada es la curva original)',
  editorSaveNext: 'Guardar y completar el siguiente',
  editorSave: 'Guardar',
  editorCancel: 'Cancelar',
  editorLeaveTitle: 'Cambios sin guardar',
  editorLeaveText: 'Si cierras ahora, se perderán los cambios en {channel}.',
  editorLeaveStepText: 'Si pasas a otro canal, se perderán los cambios en {channel}.',
  editorLeaveSave: 'Guardar',
  editorLeaveDiscard: 'Descartar',
  editorLeaveStay: 'Seguir editando',
  curveReset: 'Volver al original',
  curveCeiling: 'Ventas máximas',
  curveKneeInfo: 'Inversión mensual con la que el canal alcanza la mitad de sus ventas máximas. Muévela a la derecha para que se sature más tarde.',
  curveCeilingInfo: 'Lo máximo que puede generar este canal, sin importar cuánto se invierta.',
  curveKnee: 'Inversión de media saturación',
  curveSteepness: 'Pendiente',
  curveSteepnessInfo: 'Qué tan marcada es la curva. Por encima de 1, el canal necesita una inversión mínima antes de empezar a funcionar.',
  curveSeriesCurrent: 'Actual',
  curveSeriesOriginal: 'Original',
  curveNoteSampled: 'Estos controles no reproducen exactamente la curva original, así que mover uno también cambia su forma.',
  zonesBegin: 'Zonas óptimas',
  zoneBegins: 'Dónde empieza la {zone}',
  zoneDrag: 'Arrastra para mover dónde empieza la {zone}',
  zonesHold: 'Mantener fijo:',
  zonesHoldSaturation: 'Punto de saturación',
  zonesHoldSaturationHint: 'Al arrastrar cambia la forma de la curva; el punto de saturación no se mueve.',
  zonesHoldShape: 'Forma',
  zonesHoldShapeHint: 'Al arrastrar se desplazan todas las zonas juntas; el punto de saturación se mueve con ellas.',
  zonesHoldEdgeHint: 'Dónde empieza la {zone} no se mueve; los demás límites y el punto de saturación sí.',
  zonesNone: 'Esta curva es demasiado plana para tener zonas óptimas. Sube la Pendiente para recuperarlas.',
  zonesNoneSimple: 'Esta curva es demasiado plana para tener zonas óptimas. Abre Forma de la respuesta y sube la Pendiente para recuperarlas.',
  zonesHeld: 'Este límite es el punto de saturación, que está fijo. Edítalo en el campo junto al gráfico.',
  zonesHeldEdge: 'Este límite está fijo. Fija otra cosa para poder arrastrarlo.',
  zonesHow: 'Arrastra o escribe un límite para mover las zonas. El selector sobre la barra define qué queda fijo mientras tanto.',
  curve_stop_attribution: 'Más allá de este punto, la atribución de marketing quedaría fuera de rango.',
  curve_stop_base: 'Más allá de este punto, a los medios se les atribuiría más que las ventas totales.',
  curve_stop_floor: 'Más allá de este punto, el canal generaría menos de 1 USD al mes.',
  curveAboutTitle: 'Editor de canal',
  curveAbout: 'Ventas que genera este canal con cada nivel de inversión mensual, tomadas de su modelo de origen. Los cambios solo afectan al modelo nuevo.',
  curveHow: 'Los tres controles definen la forma de la curva. Cambiarla cambia lo que genera la misma inversión.',
  responseShapeHint: 'Ajusta la curva con la Pendiente, la Inversión de media saturación y las Ventas máximas.',
  zonesAdjust: 'Ajustar zonas',
  zonesAdjustHint: 'Arrastra los límites de las zonas y elige qué queda fijo.',
  curveSimple: 'La curva se define con el punto de saturación y sus ventas. Abre Forma de la respuesta para ajustar su forma.',
  // Guardar
  checkTitle: 'Antes de crear',
  createAnyway: 'Crear de todas formas',
  goBack: 'Volver'
}
